// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3WxYw","cell":"ColumnAccessor_cell__1OP-0","firstCellAccent":"ColumnAccessor_firstCellAccent__3uq_f"};